import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import {
  fetchReelList,
  fetchReportedReels,
  blockUnblockReel,
  deleteReel,
  fetchReelReports,
  pinUnpinReel,
} from "src/services/reel.service";

interface FetchReelListPayload {
  page: number;
  limit: number;
  search?: string;
}

export const doFetchReelList = createAsyncThunk(
  "post/fetchReelList",
  async (payload: FetchReelListPayload) => {
    try {
      const response: any = await fetchReelList({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch reel list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doFetchReportedReels = createAsyncThunk(
  "post/fetchReportedReels",
  async (payload: FetchReelListPayload) => {
    try {
      const response: any = await fetchReportedReels({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch reported reels";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doFetchReelReports = createAsyncThunk(
  "reel/fetchReelReports",
  async (pid: string) => {
    try {
      const response: any = await fetchReelReports(pid);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch reel reports";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doBlockUnblockReel = createAsyncThunk(
  "post/blockUnblockReel",
  async (pid: string) => {
    try {
      const response: any = await blockUnblockReel(pid);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to block/unblock reel";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);


export const doPinUnpinReel = createAsyncThunk(
  "post/pinUnpinReel",
  async (pid: string) => {
    try {
      const response: any = await pinUnpinReel(pid);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data.message || "Failed to pin/unpin reel";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doDeleteReel = createAsyncThunk(
  "post/deleteReel",
  async (pid: string) => {
    try {
      const response: any = await deleteReel(pid);
      toast.success(response.message);
      return { pid, ...response };
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete reel";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
